// TableComandas.jsx
import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getComandas,
  deleteComanda,
  getComandaById,
} from "../helpers/rutaComandas";
import ModalComanda from "./ModalComanda";
import DocumentoPrint from "./DocumentoPrint";
import RemitoComanda from "../plantillas/RemitoComanda";

// 👇 usa el CSS scoped para Comandas
import "../css/tablecomandas.css";

export default function TableComandas() {
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [comanda, setComanda] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => { fetchComandas(); }, []);

  const fetchComandas = () => {
    getComandas().then((d) => {
      const arr = Array.isArray(d.comandas) ? d.comandas : Array.isArray(d) ? d : [];
      setLista(arr);
      setLoading(false);
    });
  };

  const handleClose = () => { setShow(false); fetchComandas(); };
  const modificaComanda = (id) => {
    getComandaById(id).then((r) => r.ok && (setComanda(r.comanda), setShow(true)));
  };
  const eliminarComanda = (id) => {
    if (window.confirm("¿Borrar comanda?")) deleteComanda(id).then(fetchComandas);
  };

  if (loading) return <p>Cargando comandas…</p>;

  return (
    <div className="table-container">
      <div className="">
         <Table striped bordered hover className="table-container">
          <thead>
            <tr>
              <th className="acciones" style={{ width: 120, minWidth: 120, maxWidth: 120, whiteSpace: 'nowrap' }}>  Acciones</th>
              <th className="sticky codcom">Cód.</th>
              <th className="sticky viaje">Nro Viaje</th>
              <th style={{ width: 120, minWidth: 120, maxWidth: 120, whiteSpace: 'nowrap' }}>Empresa</th>
              <th style={{ width: 120, minWidth: 120, maxWidth: 120, whiteSpace: 'nowrap' }}>Transporte</th>
              <th style={{ width: 120, minWidth: 120, maxWidth: 120, whiteSpace: 'nowrap' }}>Chofer</th>
              <th>Cliente Carga</th>
              <th>Fecha Viaje</th>
              <th style={{ width: 140, minWidth: 140, maxWidth: 140, whiteSpace: 'nowrap' }}>Nro. Factura</th>
              <th>Estado</th>
              <th>Tercero</th>
              <th>Cliente Carga</th>
              <th>Origen</th>
              <th>Destino</th>
              <th>Cliente Descarga</th>
              <th>Remitos</th>
              <th>Producto</th>
              <th>Camión</th>
              <th>Estado</th>
              <th>Kg. Salida</th>
              <th>Kg. Llegada</th>
              <th>Diferencia</th>
              <th>Pactado</th>
              <th>Subtotal</th>
              <th>IVA</th>
              <th>Total</th>
              <th>Pactado Tercero</th>
              <th>Km. Salida</th>
              <th>Km Destino</th>
              <th style={{ width: 200, minWidth: 200, maxWidth: 200, whiteSpace: 'nowrap' }}>Observaciones</th>
            </tr>
          </thead>

          <tbody>
            {lista.map((c) =>
              c.activo ? (
                <tr key={c._id}>
                  <td className="sticky actions acciones">
                    <button
                      className="btn btn-primary btn-icon btn-xs"
                      title="Editar"
                      onClick={() => modificaComanda(c._id)}
                    >
                      <i className="fa fa-pencil" />
                    </button>

                    {/* <button
                      className="btn btn-danger btn-icon btn-xs ml-1"
                      title="Eliminar"
                      onClick={() => eliminarComanda(c._id)}
                    >
                      <i className="fa fa-trash-o" />
                    </button> */}

                    <DocumentoPrint
                      Plantilla={RemitoComanda}
                      data={c}
                      trigger={({ onClick }) => (
                        <button
                          className="btn btn-secondary btn-icon btn-xs ml-1"
                          title="Imprimir / PDF"
                          onClick={onClick}
                        >
                          <i className="fa fa-print" />
                        </button>
                      )}
                    />
                  </td>

                  <td className="sticky codcom">{c.codcom}</td>
                  <td className="sticky viaje">{c.nroviaje}</td>

                  <td className="dom">{c.codemp?.empresa || "-"}</td>
                  <td className="dom">{c.codtra?.transporte || "-"}</td>
                  <td className="dom">{c.codcho?.nombre || "-"}</td>
                  <td className="dom">{c.codclif?.razonsocial || "-"}</td>

                  <td>
                    {c.fecha
                      ? new Date(c.fecha).toLocaleDateString("es-AR", {
                          day: "2-digit", month: "2-digit", year: "numeric",
                        })
                      : "-"}
                  </td>

                  <td>{c.factura}</td>
                  <td className="dom">{c.estado}</td>
                  <td className="dom">{c.tercero}</td>
                  <td className="dom">{c.codclic?.razonsocial || "-"}</td>
                  <td className="dom">{c.codori?.destino || "-"}</td>
                  <td className="dom">{c.coddes?.destino || "-"}</td>
                  <td className="dom">{c.codclid?.razonsocial || "-"}</td>
                  <td className="dom">{c.remitos}</td>
                  <td className="dom">{c.codpro?.producto || "-"}</td>
                  <td className="dom">{c.codcam?.camion || "-"}</td>
                  <td className="dom">{c.codest?.estado || "-"}</td>

                  <td style={{ textAlign: "right" }}>
                    {c.kgsal?.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "-"}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {c.kglle?.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "-"}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {c.dif?.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "-"}
                  </td>

                  <td className="dom" style={{ textAlign: "right" }}>
                    {c.pactado?.toLocaleString("es-AR", { style: "currency", currency: "ARS", minimumFractionDigits: 2 }) || "-"}
                  </td>
                  <td className="dom" style={{ textAlign: "right" }}>
                    {c.subtotal?.toLocaleString("es-AR", { style: "currency", currency: "ARS", minimumFractionDigits: 2 }) || "-"}
                  </td>
                  <td className="dom" style={{ textAlign: "right" }}>
                    {c.iva?.toLocaleString("es-AR", { style: "currency", currency: "ARS", minimumFractionDigits: 2 }) || "-"}
                  </td>
                  <td className="dom" style={{ textAlign: "right" }}>
                    {c.total?.toLocaleString("es-AR", { style: "currency", currency: "ARS", minimumFractionDigits: 2 }) || "-"}
                  </td>
                  <td className="dom" style={{ textAlign: "right" }}>
                    {c.pactadoter?.toLocaleString("es-AR", { style: "currency", currency: "ARS", minimumFractionDigits: 2 }) || "-"}
                  </td>
                  <td className="dom" style={{ textAlign: "right" }}>
                    {c.kmsal?.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "-"}
                  </td>
                  <td className="dom" style={{ textAlign: "right" }}>
                    {c.kmdes?.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "-"}
                  </td>

                  <td className="textobs">{c.observ}</td>
                </tr>
              ) : null
            )}
          </tbody>
        </Table>
      </div>

      <ModalComanda show={show} handleClose={handleClose} comanda={comanda} />
    </div>
  );
}
